<template>
  <div class="advertising">
    <div class="filter-inline-panel cle">
      <el-form :inline="true" class="filter-panel">
      </el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="bianjDelete('')">新建</el-button>
      </div>
    </div>
    <div>
      <el-table :data="list" size="mini" border>
        <el-table-column prop="image" align="center" label="图片">
          <template slot-scope="scope">
              <el-image style="width: 100px; height: 100px" v-if="scope.row.image" :src="scope.row.image" fit="contain"></el-image>
              <span  v-if="!scope.row.image">无</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="bianjDelete(scope.row)">编辑</el-button>
            <el-button size="mini" type="info" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <p><br></p>
    </div>

    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
    </el-row>
    <el-dialog title="编辑" custom-class="add-data-base" :visible="addxuangDialog" @close="addxuangDialog = false" width="900px">
      <el-form label-width="100px" ref="yungong" :rules="yungongRules" :model="yungong">
        <el-row class="tree-content" :gutter="20">
          <el-col :span="12">
            <el-form-item label="图片：" prop="image">
            	<el-upload
					  class="avatar-uploader"
					   :action="http+'uploadImg'" :data="{name:'zhongzhi_image'}"
					  :show-file-list="false"
					  :on-success="imageSuccess">
					  <img v-if="yungong.image" :src="yungong.image" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addxuangDialog=false">取 消</el-button>
        <el-button type="primary" @click="yungongaddNew('yungong')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import global   from  '../../global.vue'
export default {
	data() {
		return {

			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			http:global.http,
			list:[],
			yungong:{
				image:'',
				image_y:'',
			},
			yungongRules: {
				image: [{
						required: true,
						message: '请上传图片',
						trigger: 'blur',
					},
				],
				
			},
			addxuangDialog: false,
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {

		// 图片上传
		imageSuccess(res, file) {
			console.log(res);
			if (res.status == 200) {
				console.log(res.data);
				this.yungong.image=res.data.showname;
				this.yungong.image_y=res.data.savename;
				this.$refs.yungong.clearValidate('image');
			} else {
				his_.$message.success(res.message);
			}
		},
		init: function () {
			var this_ = this;
			var url = "AdvList"
			var datas = {
				page: this_.pages.page,
				num: this_.pages.perpage,
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		bianjDelete(e) {
			if (e) {
				this.yungong = e;
			} else {
				this.yungong = {
					image: '',
				}
			}
			this.addxuangDialog = true;
		},
		yungongaddNew: function (formName) {
			var url = "AdvAction";
			var this_ = this;
			if (this_.yungong.image_y) {
				this_.$refs.yungong.validate((valid) => {
					if (valid) {
						var datas = {
							image: this_.yungong.image_y,
						}
						var tishi = '创建成功';
						if (this_.yungong.id) {
							datas['id']=this_.yungong.id;
							tishi = '修改成功';
						}
						this_.$post(url, datas).then((res) => {
							this_.$message.success(tishi);
							this_.addxuangDialog = false;
							this_.init();
						});
					} else {
						return false;
					}
				});
			}else{
				this_.addxuangDialog = false;
			}
		},

		deleteUser(index, data) {
			var this_ = this;
			var url = "AdvDelete";
			var datas = {
				id: data.id
			}
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {});
		},

		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>

</style>
<style type="text/css">
.advertising .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.advertising .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.advertising .avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}
.advertising .avatar {
	width: 178px;
	height: 178px;
	display: block;
}
.advertising .filter-inline-panel{
	margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/advertising.vue